import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { cinza } from '../../styles/constants/colors';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const GridLink = styled(Link)`
  padding: ${espacamento.pequeno}px;
  color: inherit;
  font: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${cinza.extraClaro};
  flex-basis: 50% / 2 - ${espacamento.medio}px;
  border-radius: ${bordaArredondar}px;
  line-height: 1.4;
  outline: none;
  min-height: ${(props) => (props.totem ? '230px' : '12em')};

  div {
    display: flex;
    flex: 1;
    align-items: flex-end;
    margin-top: ${(props) => (props.totem ? '40px' : 'unset')};
  }

  p {
    padding-top: 2%;
    text-align: center;
    margin: 0;
    min-height: 40px;
    font-weight: 500;
    flex: 1;
    flex-shrink: 2;
  }

  :hover, :active, :focus {
    text-decoration: none;
    border: ${({ secretaria }) => (secretaria ? '1px solid #000' : '1px solid #f7c63a')};
  }
`;

export const GridLinkInicial = styled(Link)`
  padding: ${espacamento.pequeno}px;
  color: inherit;
  font: inherit;
  border: 1px solid ${cinza.extraClaro};
  border-radius: ${bordaArredondar}px;
  line-height: 1.4;
  outline: none;
  min-height: ${(props) => (props.totem ? '230px' : '12em')};
  display: grid;
  justify-items: center;
  align-content: flex-start;

  p {
    font-weight: 500;
    text-align: center;
    margin-bottom: 0;
  }

  :hover, :active, :focus {
    text-decoration: none;
    border: 1px solid #000;
  }
`;

export const GridLinkTotemMini = styled(Link)`
  padding: ${espacamento.pequeno}px;
  color: inherit;
  height: 16em;
  font: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${cinza.extraClaro};
  flex-basis: 50% / 2 - ${espacamento.medio}px;
  border-radius: ${bordaArredondar}px;
  line-height: 1.4;
  outline: none;
  min-height: ${(props) => (props.totem ? '230px' : 'unset')};

  div {
    display: flex;
    flex: 1;
    align-items: flex-end;
    margin-top: ${(props) => (props.totem ? '40px' : 'unset')};
  }

  p {
    padding-top: 2%;
    text-align: center;
    margin: 0;
    min-height: 40px;
    font-weight: 500;
    flex: 1;
    flex-shrink: 2;
  }

  :hover, :active, :focus {
    text-decoration: none;
    border: ${({ secretaria }) => (secretaria ? '1px solid #000' : '1px solid #f7c63a')};
  }
`;

export const GridLinkLogin = styled(Link)`
  padding: 12px;
  color: inherit;
  height: 174px;
  flex: 0 0 174px;
  font: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${cinza.extraClaro};
  flex-basis: 50% / 2 - ${espacamento.medio}px;
  border-radius: ${bordaArredondar}px;
  line-height: 1.4;
  outline: none;

  div {
    display: flex;
    flex: 1;
    align-items: flex-end;
    margin-top: 40px;
  }

  p {
    padding-top: 5%;
    text-align: center;
    margin: 0;
    min-height: 40px;
    font-weight: 500;
    flex: 1;
    flex-shrink: 2;
  }

  :hover, :active, :focus {
    text-decoration: none;
    border-color: #000;
  }

  @media screen and (max-width: 800px) {
    padding: 5px;
    flex: 0 0 145px;
  }
`;

export const GridLinkTotem = styled(Link)`
  padding: ${espacamento.pequeno}px;
  color: inherit;
  height: 240px;
  font: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // border: 1px solid ${cinza.extraClaro};
  flex-basis: 50% / 2 - ${espacamento.medio}px;
  border-radius: ${bordaArredondar}px;
  line-height: 1.4;
  outline: none;
  min-height: 230px;
  min-width: 250px;
  transition: all ease-in-out .1s; 
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

  div {
    display: flex;
    flex: 1;
    align-items: flex-end;
    margin-top: ${(props) => (props.totem ? '40px' : 'unset')};
  }

  p {
    padding-top: 2%;
    text-align: center;
    margin: 0;
    min-height: 40px;
    font-weight: 500;
    flex: 1;
    flex-shrink: 2;
  }

  :hover, :active, :focus {
    text-decoration: none;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }
`;

export const GridArquivo = styled(Link)`
  padding: ${espacamento.extraPequeno}px;
  display: flex;
  height: 120px;
  justify-content: center;
  border: 1px solid ${cinza.extraClaro};
  flex-basis: 50% / 2 - ${espacamento.medio}px;
  border-radius: ${bordaArredondar}px;
  outline: none;
  transition: .2s ease-in-out;
  background-color: #eee;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    overflow: hidden;
  }

  :hover, :active, :focus {
    text-decoration: none;
    border: 1px solid #f7c63a;
  }
`;

export const Teste = styled.p``;
